import { render, staticRenderFns } from "./VerificationVerified.vue?vue&type=template&id=0b25ed6b&"
import script from "./VerificationVerified.vue?vue&type=script&lang=js&"
export * from "./VerificationVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports